const state = {
  showOverlay: false,
};

const mutations = {
  show(state) {
    state.showOverlay = true;
  },
  hide(state) {
    state.showOverlay = false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
